import React, { Component } from 'react';

import { hot } from 'react-hot-loader/root';

import Nav from 'common/Nav';

import 'css/components/_ContentWrapper.scss';

class ContentWrapper extends Component {
  render() {
    return (
      <div className="pageWrapper">
        <div>
          <Nav />
          <div className="contentWrapper">{this.props.children}</div>
        </div>
      </div>
    );
  }
}

export default hot(ContentWrapper);
